// extracted by mini-css-extract-plugin
export default {"wrapper":"NibiA","map":"ifrXr","controls":"g4d9_","error":"eRcv6"};